import type { Conversation } from '../inbox-types';

/** The longest preview a toast shows (a screen others may see). */
export const TOAST_PREVIEW_MAX = 40;

/** The OS notification's only text: it can show on a lock screen, so no name and no message. */
export const OS_NOTIFICATION_BODY = 'New WhatsApp message';

/** The SignalR event (Notifications `WhatsAppInboxRealtimeValues.Event`) and the one reason this build acts on. */
export const INBOX_CHANGED_EVENT = 'WhatsAppInboxChanged';
export const REASON_INBOUND = 'inbound';

export interface InboxChangedEvent {
  conversationId: string;
  reason: string;
  at: string;
}

/** The event payload, or null for anything else (SignalR may hand it bare or wrapped in an array). */
export function readInboxChanged(args: unknown[]): InboxChangedEvent | null {
  const head = Array.isArray(args[0]) ? (args[0] as unknown[])[0] : args[0];
  if (!head || typeof head !== 'object') return null;
  const r = head as Record<string, unknown>;
  if (typeof r.conversationId !== 'string' || !r.conversationId) return null;
  if (typeof r.reason !== 'string' || typeof r.at !== 'string') return null;
  return { conversationId: r.conversationId, reason: r.reason, at: r.at };
}

/** "New WhatsApp · <name or masked number>". The API already falls back to the masked number. */
export function toastTitle(conversation: Pick<Conversation, 'patientDisplay' | 'waPhoneMasked'>): string {
  const who = conversation.patientDisplay?.trim() || conversation.waPhoneMasked?.trim();
  return who ? `New WhatsApp · ${who}` : 'New WhatsApp message';
}

/** One line, at most TOAST_PREVIEW_MAX characters (an ellipsis included). */
export function toastPreview(text: string | null | undefined): string {
  const oneLine = (text ?? '').split(/\s+/).filter(Boolean).join(' ');
  return oneLine.length <= TOAST_PREVIEW_MAX ? oneLine : `${oneLine.slice(0, TOAST_PREVIEW_MAX - 1)}…`;
}

/** Where the toast's Open goes: the inbox (the Dashboard slot) with that thread open. */
export function inboxThreadPath(conversationId: string): string {
  return `/dashboard?conv=${encodeURIComponent(conversationId)}`;
}
